import './ol-overlays.scss';
import OlOverlay from 'ol/Overlay';
import Feature from 'ol/Feature';
import OlMap from 'ol/Map';
import { ReactUtils } from '@shared/ui-react/ReactUtils';

let dialog: OlOverlay = null;
let dialogFeature: Feature = null; // feature for currently open dialog, so we don't show tooltips on clicked/opened feature

let tooltip: OlOverlay = null;
let tooltipFeature: Feature = null;

let contextMenu: OlOverlay = null;

//region CONTEXT MENU
function showContextMenu(map: OlMap, html: any, e: number, n: number, onDone?: Function) {
    hideContextMenu(map);

    const $el = $('<div>' + html + '</div>');

    $el.on('click', 'li', () => hideContextMenu(map));

    contextMenu = new OlOverlay({
        element: $el[0] as HTMLDivElement,
        positioning: 'top-left',
        position: [e, n],
        offset: [7, 0],
        insertFirst: false,
    });

    map.addOverlay(contextMenu);

    if (onDone) {
        onDone($el);
    }
}

function hideContextMenu(map: OlMap) {
    if (contextMenu) {
        map.removeOverlay(contextMenu);
        contextMenu = null;
    }
}

//endregion

//region DIALOG
function showDialog(map: OlMap, html: any, e: number, n: number, feature?: Feature, stopEvent = true, className = 'popup dialog'): OlOverlay {
    hideDialog(map);

    // this container shouldnt be scrollable, overflow should be handled by container rendered inside, max-height here is just safeguard
    const $el = $(`<div class="${className}" style="max-height: 80vh">`);
    $el.hide().html(html);

    dialog = new OlOverlay({
        element: $el[0] as HTMLDivElement,
        positioning: 'bottom-center',
        position: [e, n],
        offset: [0, -10],
        stopEvent,
    });

    dialogFeature = feature;
    map.addOverlay(dialog);
    $el.show();
    return dialog;
}

function hideDialog(map: OlMap) {
    if (dialog) {
        ReactUtils.safeUnmountComponentAtNode(dialog.getElement());
        $(dialog.getElement()).empty();
        map.removeOverlay(dialog);
        dialog = null;
        dialogFeature = null;
    }
}

//endregion

//region TOOLTIP
function showTooltip(map: OlMap, html: any, e: number, n: number, feature?: Feature) {
    if (!html) return;

    if (tooltip && feature && tooltipFeature == feature) {
        // already exists, update html and position
        tooltip.getElement().innerHTML = html;
        tooltip.setPosition([e, n]);
    } else {
        hideTooltip(map);

        tooltip = new OlOverlay({
            element: $('<div style="pointer-events: none">' + html + '</div>')[0] as HTMLDivElement,
            positioning: 'bottom-center',
            position: [e, n],
            offset: [0, -15],
        });

        map.addOverlay(tooltip);
        $(tooltip.getElement()).parent().addClass('pointer-none');
        tooltip.setPosition([e, n]); // need to set position like this to prevent flicker on first show
        tooltipFeature = feature;
    }
}

function hideTooltip(map: OlMap) {
    tooltipFeature = null;

    if (tooltip) {
        map.removeOverlay(tooltip);
        $(tooltip.getElement()).parent().removeClass('pointer-none');
        tooltip = null;
    }
}

//endregion
let overlays: {
    instance: OlOverlay;
    props: IMapOverlayProps;
}[] = [];

interface IMapOverlayProps {
    // openlayers overlay props
    positioning: 'bottom-left' | 'bottom-center' | 'top-left';
    position: [number, number];
    offset: [number, number];

    // todo, not implemented
    // additional props
    // replace all above (tooltip, context, dialog) with this generic
    group?: ''; // so we can select/remove by group
    feature?: Feature;
    closeOthersOnOpen?: boolean;
    hideOn?: {
        click?: boolean;
        rightClick?: boolean;
        move?: boolean;
        zoom?: boolean;
        sameGroupOpened?: boolean;
    };
}

function addOverlay(map: OlMap, props: IMapOverlayProps) {
    const element = document.createElement('div');
    document.body.appendChild(element);

    const instance = new OlOverlay({
        element,
        ...props,
    });

    map.addOverlay(instance);
    overlays.push({
        instance,
        props,
    });

    return {
        element,
        overlay: instance,
    };
}

function hideAllOverlays(map: OlMap) {
    hideContextMenu(map);
    hideTooltip(map);
    hideDialog(map);

    //overlays.forEach(o => map.removeOverlay(o));
    //overlays.length = 0;
}

function hideForMapEvent(map: OlMap, event: 'click' | 'right-click' | 'move' | 'zoom') {
    const [toRemove, toKeep] = _.partition(overlays, o => {
        if (!o.props.hideOn) return false;
        if (event === 'click') return o.props.hideOn.click;
        if (event === 'right-click') return o.props.hideOn.rightClick;
        if (event === 'move') return o.props.hideOn.move;
        if (event === 'zoom') return o.props.hideOn.zoom;
    });

    toRemove.forEach(o => map.removeOverlay(o.instance));
    overlays = toKeep;
}

export const MapOverlays = {
    showContextMenu,
    hideContextMenu,
    showDialog,
    hideDialog,
    showTooltip,
    hideTooltip,
    hideAllOverlays,
    hideForMapEvent,
    addOverlay,
    getDialogFeature: () => dialogFeature,
};
